import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class OperatoriService {
	private token!: string;
	private httpOptions: any;

	private basePath = environment.interop.basePath;
	private getOperatorCerereByIdUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.operatori.getOperatorCerereById;

	private updateOperatorUrl =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.operatori.updateOperator;

	private getPersmisiuniList =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.operatori
			.getOperatorPermisiuniList;

	private getOperatorListId =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.operatori.getOperatorCerereById;

	private postOperatorListId =
		this.basePath +
		environment.interop.autorizatiiComerciale.nomenclatoare.operatori.updateOperator;
	
	private getOperatorFunctieUrl = this.basePath + environment.interop.autorizatiiComerciale.nomenclatoare.operatori.getOperatorFunctie;
	private updateOperatorFunctieUrl = this.basePath + environment.interop.autorizatiiComerciale.nomenclatoare.operatori.updateOperatorFunctie;

	constructor(private http: HttpClient) { }	

	getOperatorById(id: number) {
		return this.http.get(this.getOperatorCerereByIdUrl + '/' + id);
	}

	updateOperator(operator: any) {
		return this.http.put(this.updateOperatorUrl, operator, this.httpOptions);
	}
	permisiuniList(id: number) {
		return this.http.get<{ errors: boolean; data: any[]; status_code: number }>(
			this.getPersmisiuniList + '/' + id,
			this.httpOptions
		);
	}

	operatorListIds(id: number) {
		// return is simple, [1,2,3]
		return this.http.get(this.getOperatorListId + id, this.httpOptions);
	}

	postUpdateOperator(id: number, data: any) {
		// basically a simple array with numbers [1,2,3]
		return this.http.post(this.postOperatorListId + '/' + id, data);
	}

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}

	getOperatorFunctie(id: number) {
		return this.http.get(this.getOperatorFunctieUrl + id);
	}

	updateOperatorFunctie(user_id: number, data: any) {
		return this.http.put(this.updateOperatorFunctieUrl + user_id, data, this.httpOptions);
	}
}
